import {Directive, Input, TemplateRef} from '@angular/core';

@Directive({
    selector: '[mydocmaStep]'
})
export class StepTemplateDirective {

    @Input()
    public mydocmaStep: string;

    constructor(public template: TemplateRef<any>) {
    }
}
